import axios from '../_utils/axios';
import store, { DELETE_LOADER, persistor} from '../../store';
import getAccount from './getAccount';

// ----------------------------------------------------------------------

const receiveAlarm = async (receiveAlarm: boolean) => {
  return await axios.put('accounts/receive-alarm', {receiveAlarm})
    .then(() => getAccount())
    .catch((error) => {
      const code = error.response.data.code;
      
      if ( error.code === 'ERR_BAD_RESPONSE' ) {
        persistor.purge();
        return window.location.href = '/alert';
      } else if ( code === 'ERR-001' || code === 'ERR-REISSUE' ) {
        persistor.purge();
        return window.location.href = '/login';
      } else {
        return Promise.reject(
          new Error( code === 'ERR-106' ?
            '계정 관리를 통해 이메일 등록을 먼저 진행해 주세요.'
            : '알람 설정을 할 수 없습니다. 나중에 다시 시도해 주세요.'
          )
        );
      }
    })
    .finally(() => store.dispatch( DELETE_LOADER() ));
};

export default receiveAlarm;